import React from 'react';
import { getFormattedTimeRange } from '@lmt/unicorn-shared/app/components/patients/common';
import { AppointmentStatusCodes } from '@lmt/shared-types';

import styles from './RecentVisitsPanel.module.scss';

export interface RecentVisitInfo {
  id: number;
  caseId: number;
  startDate: Date;
  endDate: Date;
  patientId: number;
  patientName: string;
  subtenantCode: string;
  statusId: AppointmentStatusCodes;
  visitType: string;
}

export interface Props {
  visit: RecentVisitInfo;
  openPatientTab: (patientId: number) => void;
  openCaseVisitTab: (
    patientId: number,
    caseId: number,
    visitId: number,
  ) => void;
}

export const RecentVisitItem: React.FC<Props> = (props) => {
  const { visit, openCaseVisitTab, openPatientTab } = props;

  return (
    <div
      className={styles.visit}
      onClick={() => openCaseVisitTab(visit.patientId, visit.caseId, visit.id)}
    >
      <div className={styles.timeRange}>
        {getFormattedTimeRange(visit.startDate, visit.endDate)}
      </div>
      <div className={styles.visitInfoColumn}>
        <div className={styles.patientContainer}>
          <div
            className={styles.patient}
            onClick={(e) => {
              e.stopPropagation();
              openPatientTab(visit.patientId);
            }}
          >
            <div title={visit.patientName} className={styles['patient-name']}>
              {visit.patientName}
            </div>
          </div>
          <div className={styles.subtenantCode}>{visit.subtenantCode}</div>
        </div>
        <div className={styles.visitType}>{visit.visitType}</div>
      </div>
    </div>
  );
};
